'use strict';
app.service("geoStreamApiService", function ($rootScope, $http, $timeout) {
        const urlGISAPI = $rootScope["giswebApiurl"];
        const CONFIG = {
            SAS_BACKEND_URL: `${urlGISAPI}mapfilestorage/get_sas_url`,
            CANCEL_BACKEND_URL: `${ urlGISAPI }mapfilestorage/cancel_upload`,
            CREATE_RECORD_BACKEND_URL: `${urlGISAPI}mapfilestorage/create_record_upload_log`,
            GET_RECORD_STATUS_URL: `${urlGISAPI}mapfilestorage/get_record_status_log`,
            SAVE_DATA_TRANS_URL: `${urlGISAPI}mapfilestorage/save_data_trans`,
            GET_DATA_TRANS_URL: `${urlGISAPI}mapfilestorage/get_data_trans`
        };

        this.getSasData = async function (clientCode, ouCode, filename, type) {
            try {
                const response = await $http({
                    method: 'GET',
                    url: CONFIG.SAS_BACKEND_URL,
                    params: {
                        clientCode: clientCode,
                        ouCode: ouCode,
                        filename: filename,
                        type: type
                    }
                });

                return response.data;

            } catch (err) {
                throw new Error('Error. The request to upload file is unauthorized. Please contact support.');
            }
        };

        this.saveDataTrans = async function (clientCode, ouCode) {
            const url = CONFIG.SAVE_DATA_TRANS_URL;
            try {
                await $http({
                    method: 'POST',
                    url: url,
                    headers: {
                        "Content-Type": "application/json"
                    },
                    data: {
                        ClientCode: clientCode,
                        OuCode: ouCode
                    }
                });
            }
            catch (err) {
                console.error("Save record failed", err);
                throw err;
            }
        };

        this.getDataTrans = async function (ouKey) {
            try {
                const response = await $http({
                    method: 'GET',
                    url: CONFIG.GET_DATA_TRANS_URL,
                    params: {
                        ouKey: ouKey
                    },
                    responseType: 'json'
                });

                return response.data;
            }
            catch (err) {
                console.error("Get data trans failed", err);
                throw err;
            }
        };

        this.notifyCreateRecord = async function (clientCode, ouCode, layerState, type) {
            const url = CONFIG.CREATE_RECORD_BACKEND_URL;

            try {
                await $http({
                    method: 'POST',
                    url: url,
                    headers: {
                        "Content-Type": "application/json"
                    },
                    data: {
                        ClientCode: clientCode,
                        OuCode: ouCode,
                        JobId: layerState.status.jobId,
                        OriginalFullBlobPath: layerState.status.originalFullBlobPath,
                        OriginalRelativeBlobPath: layerState.status.originalRelativeBlobPath,
                        LayerType: type
                    }
                });
            }
            catch (err) {
                console.error("Create record failed", err);
                throw err;
            }
        };

        this.notifyCancelRecord = async function (clientCode, ouCode, jobId, type) {
            const url = CONFIG.CANCEL_BACKEND_URL;

            try {
                await $http({
                    method: 'POST',
                    url: url,
                    headers: {
                        "Content-Type": "application/json"
                    },
                    data: {
                        ClientCode: clientCode,
                        OuCode: ouCode,
                        JobId: jobId,
                        LayerType: type
                    }
                });
            }
            catch (err) {
                console.error("Cancel record failed", err);
                throw err;
            }
        };

        this.getUploadAuditInfo = async function (clientCode, ouCode, jobId) {
            try {
                const response = await $http({
                    method: 'GET',
                    url: CONFIG.GET_RECORD_AUDIT_INFO_URL,
                    params: {
                        clientCode: clientCode,
                        ouCode: ouCode,
                        filename: filename,
                        type: type
                    }
                });

                return response.data;

            } catch (err) {
                throw new Error('Error. The request to upload file is unauthorized. Please contact support.');
            }
        }

        this.pollProcessingStatus = async function (clientCode, ouCode, jobId, type, onProgress, onComplete, onError) {
            const pollingStartedAt = Date.now();
            let hasProgress = false;
            const TIMEOUT_IF_NO_PROGRESS_IN_SECONDS = 2 * 60 * 1000;
            const poll = async () => {
                try {
                    const response = await $http({
                        method: 'GET',
                        url: CONFIG.GET_RECORD_STATUS_URL,
                        params: {
                            clientCode: clientCode,
                            ouCode: ouCode,
                            jobId: jobId,
                            type: type
                        }
                    });

                    const data = response.data;
                    const progress = data.Percent || 0;

                    if (progress > 0) {
                        hasProgress = true;
                    }

                    onProgress(progress);

                    if (!hasProgress && (Date.now() - pollingStartedAt) >= (TIMEOUT_IF_NO_PROGRESS_IN_SECONDS)) {
                        throw new Error('Processing timed out after 2 minutes with no progress. Please contact support.');
                    }

                    if (data.Status === 'PROCESSED' || data.Percent === 100) {
                        onComplete(data.DestFilename);
                        return;
                    }
                    else if (data.Status === 'ERROR') {
                        throw new Error(data.Remarks || 'Processing failed');
                    }

                    $timeout(poll, 2500);

                } catch (err) {
                    onError(err);
                }
            };

            await poll();
        };

        this.publishToLive = async function (clientCode, ouCode, jobId, type, liveUrl) {
            try {
                const response = await $http.post(liveUrl, {
                    clientCode: clientCode,
                    ouCode: ouCode,
                    jobId: jobId,
                    type: type
                });

                return response.data;

            }
            catch (err) {
                const status = err?.status || 'unknown';
                throw new Error(`Failed to publish live (${status})`);
            }
        };

        this.publishPreviewLayer = async function (clientCode, ouCode, jobId, type, previewUrl) {
            try {
                const response = await $http.post(previewUrl, {
                    clientCode: clientCode,
                    ouCode: ouCode,
                    jobId: jobId,
                    type: type
                });

                return response.data;

            }
            catch (err) {
                const status = err?.status || 'unknown';
                throw new Error(`Failed to publish preview layer - (${status})`);
            }
        };

        this.deleteStore = async function (clientCode, ouCode, type, deleteUrl) {
            try {
                await $http.post(deleteUrl, {
                    clientCode: clientCode,
                    ouCode: ouCode,
                    type: type
                });

                return true;

            }
            catch (err) {
                const status = err?.status || 'unknown';
                throw new Error(`Failed to delete (${status})`);
            }
        };

        this.checkLayerExistence = async function (geoserverUrl, workspace, layer) {
            const checkUrl = `${geoserverUrl}${workspace}/wms?service=WMS&version=1.1.1&request=GetMap&layers=${encodeURIComponent(workspace + ':' + layer)}&styles=&bbox=0,0,1,1&width=1&height=1&srs=EPSG:4326&format=image/png`;
            const response = await fetch(checkUrl);
            const contentType = response.headers.get("Content-Type");
            return response.ok && contentType && contentType.includes("image/png");
        };
    });
